import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';
import { OracleFusionLinkedService } from 'app/model/linkedservice/oracle-fusion.linkedservice';

@Metamodel.model({
    name: 'OracleFusionTable',
    display: [],
    constraints: {
        linkedService: {
            model: OracleFusionLinkedService.MODEL
        }
    }
})
export class OracleFusionTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}